module.exports = __webpack_public_path__ + "static/media/zebra04.6b1340ec.png";